import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { useCategoryColors } from '../contexts/CategoryColorsContext';

const DEFAULT_DOT = '#CBD5E1';

const CategoryColorPicker = ({ category, size = 'sm' }) => {
  const { getColor, setCategoryColor, presets } = useCategoryColors();
  const [open, setOpen] = useState(false);
  const current = getColor(category);
  const display = current || DEFAULT_DOT;

  const dotSize = size === 'lg' ? 'w-5 h-5' : 'w-3.5 h-3.5';

  if (!category) {
    return <span className={`inline-block ${dotSize} rounded-full bg-[#E2E8F0]`} />;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`inline-block ${dotSize} rounded-full border border-[#E2E8F0] hover:scale-110 transition-transform`}
          style={{ backgroundColor: display }}
          aria-label={`Set colour for ${category}`}
          data-testid={`color-dot-${category}`}
          onClick={(e) => e.stopPropagation()}
        />
      </PopoverTrigger>
      <PopoverContent className="w-64 bg-white p-4" align="start" data-testid="color-picker-popover">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B] mb-2">Colour for &quot;{category}&quot;</div>
        <div className="grid grid-cols-5 gap-2 mb-3">
          {presets.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => { setCategoryColor(category, c); setOpen(false); }}
              className="w-8 h-8 rounded-full border border-[#E2E8F0] hover:scale-110 transition-transform"
              style={{ backgroundColor: c }}
              data-testid={`color-preset-${c}`}
              aria-label={`Set colour to ${c}`}
            />
          ))}
        </div>
        <div className="flex items-center gap-2">
          <Input
            type="color"
            value={current || '#0052FF'}
            onChange={(e) => setCategoryColor(category, e.target.value)}
            className="w-12 h-9 p-1 cursor-pointer"
            data-testid="color-custom-input"
          />
          <span className="text-xs text-[#64748B]">Custom</span>
          <Button
            type="button"
            onClick={() => setOpen(false)}
            className="ml-auto bg-[#F1F5F9] text-[#020617] hover:bg-[#E2E8F0] text-xs px-3 py-1.5"
            data-testid="color-close-button"
          >
            Done
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default CategoryColorPicker;
